module.exports = __webpack_public_path__ + "static/img/地科師資介紹.1d02936b.png";